export default __webpack_public_path__ + "static/media/cancel.8abd6eac.svg";